import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { MatListItem } from '@angular/material/list';
import { Observable, map, shareReplay } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { DashboardUserService } from 'src/app/services/dashboard-user.service';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css'],
    standalone: false
})
export class NavbarComponent {

  isHandset$: Observable<boolean> = this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.XSmall, Breakpoints.Medium])
  .pipe(
    map(l_result => l_result.matches),
    shareReplay()
  );


  constructor(private breakpointObserver: BreakpointObserver,public authService: AuthService,public themeService: ThemeService,
    public dashboardUserService: DashboardUserService) { }
  

  async logout() {
    await this.authService.logout();
  }

  getLogoSrc(): string
  {
    return this.themeService.getLogoPath()
  }

  getUserName():string{
    return  this.dashboardUserService.currentUserName
  }

  deselectOther(element: MatListItem)
  {
    let l_parent = element._hostElement.parentNode
    let l_elements = l_parent?.querySelectorAll('a')
    if (l_elements && l_elements.length > 0)
    {
      l_elements.forEach(l_sibling =>
      {
        l_sibling.classList.add('unselected')
      })
    }

  }

  returnSelection(element: MatListItem)
  {
    let l_elements = element._hostElement.parentNode?.querySelectorAll('a')
    if (l_elements && l_elements.length > 0)
    {
      l_elements.forEach(l_sibling =>
      {
        l_sibling.classList.remove('unselected')
      })
    }
  }
}
